import { useTranslation } from 'react-i18next';
import type { ReportMeta } from '@optiflow/types';

/** Which days, which calendars and when: every figure on the page is read against this line. */
export function ReportMetaLine({ meta }: { meta: ReportMeta }) {
  const { t } = useTranslation();
  const zones = [...new Set(meta.branches.map((branch) => branch.timezone))];
  return (
    <p className="text-muted text-xs">
      {t('reports.meta.period')}{' '}
      <span dir="ltr">
        {meta.period.from === meta.period.to
          ? meta.period.from
          : `${meta.period.from} – ${meta.period.to}`}
      </span>
      {meta.comparison ? (
        <>
          {' · '}
          {t('reports.meta.comparedWith')}{' '}
          <span dir="ltr">
            {meta.comparison.from === meta.comparison.to
              ? meta.comparison.from
              : `${meta.comparison.from} – ${meta.comparison.to}`}
          </span>
        </>
      ) : null}
      {' · '}
      {t('reports.meta.timezones')} <span dir="ltr">{zones.join(', ')}</span>
      {' · '}
      {t('reports.meta.asOf')} <span dir="ltr">{meta.asOfDate}</span>
    </p>
  );
}
